export default "__VITE_ASSET__GU5AOIl0__";